import { ReactNode } from 'react'

import { StaticImageData } from 'next/image'

import {
  EmajinWhatIsIconsImage,
  EmajinWhatIsImage,
  EmajinWhoIsIconsImage,
  EmajinWhoIsImage,
  EmajinWhyJoinIconsImage,
  EmajinWhyJoinImage,
} from 'Assets/Images/Sections/EmajinMembershipsSection'

import { ABOUT_US } from 'Constants/Paths'
import { OFFER_URL } from 'Constants/Values'

export enum EmajinSectionQuestionItemActionId {
  OpenGetInTouchForm = 'OpenGetInTouchForm',
}

export type EmajinSectionQuestionItem = {
  id: string
  title: string
  subtitle: string
  plainText: ReactNode
  buttonCaption: string
  backgroundImage: StaticImageData
  backgroundImageAlt: string
  iconImage: StaticImageData
  iconImageAlt: string
  link?: string
  actionId?: EmajinSectionQuestionItemActionId
}

export const EMAJIN_SECTION_QUESTION_ITEMS: EmajinSectionQuestionItem[] = [
  {
    id: 'EmajinSectionQuestionItem-001',
    title: 'What is Emajin Golf?',
    subtitle: "It's networking done the smart way.",
    plainText: (
      <>
        Emajin Golf was created to connect business owners and C-Suite
        Executives to tee you up for success.
        <br />
        <br />
        True relationships AREN’T built over small talk! They require a shared,
        enjoyable experience – and what better way than 18 Holes on Australia’s
        top Golf Courses?
      </>
    ),
    buttonCaption: 'Learn More',
    backgroundImage: EmajinWhatIsImage,
    backgroundImageAlt: '',
    iconImage: EmajinWhatIsIconsImage,
    iconImageAlt: '',
    link: ABOUT_US,
  },
  {
    id: 'EmajinSectionQuestionItem-002',
    title: 'Who is Emajin Golf for?',
    subtitle: 'Business Professionals looking to expand their network.',
    plainText: (
      <>
        Emajin Golf is for business professionals looking for a better, more
        genuine way to connect.
        <br />
        <br />
        Leave the boardroom setting behind. Emajin Golf allows elite, avid and
        beginner golfers to access opportunities unlike any other format.
      </>
    ),
    buttonCaption: 'Apply Now',
    backgroundImage: EmajinWhoIsImage,
    backgroundImageAlt: '',
    iconImage: EmajinWhoIsIconsImage,
    iconImageAlt: '',
    actionId: EmajinSectionQuestionItemActionId.OpenGetInTouchForm,
  },
  {
    id: 'EmajinSectionQuestionItem-003',
    title: 'Why join Emajin Golf?',
    subtitle: 'Relaxed. Personalised. Effective. Conducive.',
    plainText: (
      <>
        In the digital age, it’s time to get back to nurturing genuine
        connections with in-person experiences.
        <br />
        <br />
        Emajin Golf’s close-knit community of high-calibre business
        professionals lets you build meaningful relationships and bond in a
        conducive setting.
      </>
    ),
    buttonCaption: 'Explore Our Membership',
    backgroundImage: EmajinWhyJoinImage,
    backgroundImageAlt: '',
    iconImage: EmajinWhyJoinIconsImage,
    iconImageAlt: '',
    link: OFFER_URL,
  },
]
